export class RegistrationActivityCondition {
  public id: string;
  public activityConditionId: string;
  public jsonDeterminants: string;
  public sortOrder: number;
}
